import React from 'react';
import { Star } from 'lucide-react';

/**
 * Componente de exibição de estrelas
 * @param {number} rating - Nota de 1 a 5
 * @param {string} size - Tamanho: 'sm', 'md', 'lg'
 * @param {boolean} interactive - Se permite clicar para selecionar
 * @param {function} onRatingChange - Callback quando muda a nota (se interactive)
 */
const StarRating = ({ 
  rating = 0, 
  size = 'md', 
  interactive = false, 
  onRatingChange = null,
  showValue = false 
}) => {
  const [hoverRating, setHoverRating] = React.useState(0);

  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  const handleClick = (value) => {
    if (interactive && onRatingChange) {
      onRatingChange(value);
    }
  };

  const displayRating = hoverRating || rating;

  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((value) => (
        <button
          key={value}
          type="button"
          onClick={() => handleClick(value)}
          onMouseEnter={() => interactive && setHoverRating(value)}
          onMouseLeave={() => interactive && setHoverRating(0)}
          disabled={!interactive}
          className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'}`}
        >
          <Star
            className={`${sizes[size]} ${
              value <= displayRating 
                ? 'fill-yellow-400 text-yellow-400' 
                : 'fill-gray-600 text-gray-600'
            } transition-colors`}
          />
        </button>
      ))}
      {showValue && rating > 0 && (
        <span className="ml-2 text-sm text-gray-400">
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
};

export default StarRating;
